import React from 'react';
import AvatarCarousel from '../features/navigation/AvatarCarousel/AvatarCarousel';
import { PhotosByEvent } from '../../types';
import { OrganizedSeasonData } from '../../types/seasonTypes';
import { parseSeasonId, formatSeasonDisplay } from '../../utils/seasonHelpers';
import { EmptySeasonCard } from '../shared/EmptyState/EmptySeasonCard';
import { useAdminStore } from '../../stores/useAdminStore';
import { BaseInlineActions } from '../admin/BaseInlineActions';
import { SeasonContext } from '../../types';
import './SeasonContainer.css';

interface SeasonContainerProps {
    seasonId: string;
    seasonEvents: PhotosByEvent;
    onAvatarClick: (event: string | null, seasonId: string) => void;
    openEvent: string | null;
    organizedSeasonData?: OrganizedSeasonData;
}

const SeasonContainer: React.FC<SeasonContainerProps> = ({
    seasonId,
    seasonEvents,
    onAvatarClick,
    openEvent,
    organizedSeasonData
}) => {
    const isAdminMode = useAdminStore(s => s.isAdminMode);
    const openSeasonActionsModal = useAdminStore(s => s.openSeasonActionsModal);

    const parsedSeason = parseSeasonId(seasonId);
    const seasonContext: SeasonContext | undefined = parsedSeason ? {
        seasonId,
        seasonName: parsedSeason.name,
        year: parsedSeason.year
    } : undefined;

    const displayName = formatSeasonDisplay(seasonId);

    const isEmpty = organizedSeasonData?.isEmpty || Object.keys(seasonEvents).length === 0;

    return (
        <div className="season-container">
            <div className="season-header">
                <h2 className="season-heading">{displayName}</h2>
                {isAdminMode && seasonContext && (
                    <BaseInlineActions
                        title="Season actions"
                        ariaLabel="Open season actions menu"
                        onClick={() => openSeasonActionsModal(seasonContext)}
                        className="inline-season-actions"
                        data-testid="season-actions-gear"
                    >
                        ⚙️
                    </BaseInlineActions>
                )}
            </div>

            {isEmpty && !isAdminMode ? (
                <EmptySeasonCard
                    seasonId={seasonId}
                />
            ) : (
                <AvatarCarousel
                    onAvatarClick={(event) => onAvatarClick(event, seasonId)}
                    openEvent={openEvent}
                    seasonEvents={seasonEvents}
                    seasonContext={seasonContext}
                />
            )}
        </div>
    );
};

export default SeasonContainer;
